import Vue from 'vue'

import FormContainer from '@/components/base/formContainer'
import LayoutNoPadding from '@/components/base/layoutNoPadding'
import SnackBar from '@/components/base/snackBar'
import TimeAgo from '@/components/misc/timeAgo.vue'
import TopRightAbsolute from '@/components/base/topRightAbsolute'
import CardDividerSplit from '@/components/base/cardDividerSplit'
import CardDividerFull from '@/components/base/cardDividerFull'
import PageTitle from '@/components/base/pageTitle'
import BasicListTile from '@/components/base/basicListTile'
import FancyListTile from '@/components/base/fancyListTile'
import FlexSubHeader from '@/components/base/flexSubHeader'
import CardDividerHeader from '@/components/base/cardDividerHeader'
import GoBack from '@/components/base/goBack'
import ConfirmationCard from '@/components/base/confirmationCard'
import ControlCard from '@/components/base/controlCard'
import FirstLastPage from '@/components/base/firstLastPage'

Vue.component('form-container', FormContainer);
Vue.component('layout-no-padding', LayoutNoPadding);
Vue.component('snack-bar', SnackBar);
Vue.component('time-ago', TimeAgo);
Vue.component('top-right-absolute', TopRightAbsolute);
Vue.component('card-divider-split', CardDividerSplit);
Vue.component('card-divider-full', CardDividerFull);
Vue.component('page-title', PageTitle);
Vue.component('basic-list-tile', BasicListTile);
Vue.component('fancy-list-tile', FancyListTile);

Vue.component('flex-sub-header', FlexSubHeader);
Vue.component('card-divider-header', CardDividerHeader);
Vue.component('go-back', GoBack);
Vue.component('confirmation-card', ConfirmationCard);
Vue.component('control-card', ControlCard);
Vue.component('first-last-page', FirstLastPage);

Vue.mixin({
  data() {
    return {
      primaryNeutral: 'indigo',
      primaryGrey: 'grey darken-2',
      primaryGreen: 'green',
      // itemsPerPageOptions: [
      //     10, 20, 40, {"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}
      // ]
      itemsPerPageOptions: [
        10, 20, 40, 50
      ]
    }
  },
  methods: {
    titleCase(str) {
      //return str.toLowerCase()
      return str.replace(/\w\S/g, function (t) { return t.toUpperCase() });
    },
    getUTCTime(string) {
      //console.log('STRING', string);
      if (!string) return string
      var date = new Date(Date.parse(string));
      //console.log('DATE', date);

      var hours = date.getUTCHours();
      var mins = date.getUTCMinutes();

      if (hours < 10) hours = `0${hours}`;
      if (mins < 10) mins = `0${mins}`;
      return `${hours}:${mins}`;
    },
    getProperCase(string) {
      return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    },
    addCommas(number) {
      const arr = number.split('.')
      return `${arr[0].toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}${arr[1] ? '.' + arr[1] : ''}` 
    },
    snackError() {
      this.$store.dispatch('global/displaySnackbar', { color: "red", text: "An error occured!" });
    },
    snack(options) {
      this.$store.dispatch('global/displaySnackbar', options);
    },
    getObjByPrimaryId(id, array) {
      var result = array.filter(obj => {
        return obj.id === id
      })
      return result[0];
    },
    getObjByProp(value, prop, array) {
      var result = array.filter(obj => {
        return obj[prop] === value
      })
      return result[0];
    },
    getObjectPath(path, object) {
      var props = path.split(".");

      while (props.length > 1) {
        object = object[props.shift()];
      }
      object = object[props.shift()];
      return object;
    },
    getObjectPathRootExists(path, object) {
      // var props = path.split(".");
      // if (!!object[props[0]]) {
      //     return true;
      // } 
      // return false;
      var props = path.split(".");
      while (props.length > 1) {
        object = object[props.shift()]
      }
      return !!object

      // if (!!object[props[0]]) {
      //     return true;
      // } 
      // return false;
    },
    getObjectFromArray(array, prop, value) {
      return array.filter(item => {
        return item[prop] == value
      })[0]
    },
    searchByAttr(array, attr, value) {
      var arrLeng = array.length
      for (var i = 0; i < arrLeng; i++) {
        if (array[i][attr] === value) {
          return i;
        }
      }
      return -1;
    },
  },
  computed: {
    userAuthClass() {
      var route = this.$route.name
      if (route == 'project' || route == 'site' || route == 'rate') { route = 'client' }
      if (route == 'vehicle' || route == 'driver' || route == 'vehicleType') { route = 'contractor' }
      if (route == 'confirmedTrip') { route = 'rcti' }
      if (route == 'confirmedTripBilling') { route = 'billing' }
      if (route == 'spoil') { route = 'tip' }
      return this.$store.state.user.userAuthClass[`${route}Write`]
    },
    userShowCost() {
      return this.$store.state.user.userAuthClass.showCost
    },
    userShowSell() {
      return this.$store.state.user.userAuthClass.showSell
    },
    allowInductionEntry() {
      return this.$store.state.user.userAuthClass.allowInductionEntry
    }
  }
})